import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

export default function LoaderComponent() {
    return (
        <Box
            alignItems="center"
            justifyContent="center"
            sx={{
                display: 'flex',
                width: { md: '33%', xs: '100%' },
                height: '100vh',
                position: 'absolute',
                backgroundColor: 'rgba(255, 255, 255 ,0.7)',
                zIndex: 10
            }}>
            <CircularProgress size="8em" />
        </Box>
    );
}
